const company_id = "P2sVb8";

const messages = {
  success: `<div class="banner banner--success">You're signed up! Keep an eye on your inbox! 👀</div>`,
  error: `<div class="banner banner--error">Sorry, there appears to have been an error. Please check back later.</div>`
}

function subscribe(listId, email, source = "", form) {
  console.log('listId', listId);
  
  const options = {
    method: 'POST',
    headers: {revision: '2024-02-15', 'content-type': 'application/json'},
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              },
            }
          }
        },
        relationships: {list: {data: {type: 'list', id: listId}}}
      }
    })
  };

  return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${company_id}`, options)
  .then(response => {
    if (form) {
      if (response.ok) {
        form.innerHTML = messages.success;
      } else {
        form.innerHTML = messages.error;
      }
    }
    console.log(response)
  })
  .catch(err => console.error(err));
}

const submitEmailToKlaviyo = async (form, email, variantId, sub) => {
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      revision: "2024-02-15",
      "content-type": "application/json"
    },
    body: JSON.stringify({
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email
              }
            }
          },
          channels: ["EMAIL"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    })
  };
  
  fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${company_id}`, options)
    .then(response => {
      if (sub) {
        subscribe("UHmmAY", email, 'back-in-stock', null);
      }
      if (form) {
        if (response.ok) {
          form.innerHTML = messages.success;
        } else {
          form.innerHTML = messages.error;
        }
      }
      console.log(response)
    })
    .catch(err => {
      form.innerHTML = messages.error;
      console.error(err)
    });
}

const urlVals = ['intialUrl', 'signupUrl']

const submitForm = form => {
  console.log('submitForm()');
  
  let formData = {};
  [...form.elements].forEach(input => {
    if (input.value) formData[input.name] = input.value;
  });
  
  if (form.getAttribute('id') === 'prefooter-email__form') {
    handleGTMPush(formData.email)
    const urlData = getUrlData()
    formData['$fields'] = urlVals
    formData = {...formData, ...urlData}
  }
  
  if (form.getAttribute('id') === 'product-register-form') {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(formData);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://hook.us1.make.com/u1ure3nxih83b6qo5okaqijsy2kmcg7b", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (form.dataset.redirect) window.location.pathname = form.dataset.redirect;
      })
      .catch(error => console.log('error', error));
  } else {
    // Must have hidden $fields input or no custom formData will be sent!
    console.log('formData', formData["contact[email]"]);
    
    formData['$fields'] = urlVals
    subscribe(form.dataset.list, formData["contact[email]"], "", form).then(data => {
      form.parentNode.classList.add('form--submitted');
    });
  }
};

const setInitialVisitUrl = () => {
  const url = window.localStorage.getItem('mb_first_link')
  if(url) {
    return
  } else {
    window.localStorage.setItem('mb_first_link', window.location.href)
  }
}

const getUrlData = () => ({
  intialUrl: window.localStorage.getItem('mb_first_link'), 
  signupUrl: window.location.href
})

const handleGTMPush = (email) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'emailCapture', 
    emailCampaign: {
      provider: 'native', 
      type:'signup', 
      email: email, 
      campaign: 'prefooter-form'
    }, 
    eventCallback: function() {console.log('tags submitted')}
  });
}

const checkFormValidity = e => {
  e.preventDefault();
  const form = e.target;
  const isValidForm = form.checkValidity();
  console.log(isValidForm);
  if (isValidForm) {
    submitForm(form);
  } else {
    form.classList.add('form-error');
  }
};

document.addEventListener("DOMContentLoaded", function(e) {
  const forms = document.querySelectorAll('form[data-list]');
  [...forms].forEach(form => {
    form.addEventListener('submit', checkFormValidity);
  });
  setInitialVisitUrl();
})
